<template>
  <div>
    <el-dialog
      title="申请分批发货"
      :visible.sync="dialogVisible"
      width="1000px"
      class="partShipment"
      @open="partDialogOpen"
      @close="closeDialog"
    >
      <p>
        产品信息<span
          style="display: inline-block; color: red; margin-left: 50px"
        >
          <span>注：货运方式为供应商直发的产品预计在提交申请三天后发货</span>
          <span v-if="this.specialCloudDesc">;{{ this.specialCloudDesc }}</span>

        </span>
      </p>

      <el-table
        v-loading="loading"
        :data="tableData_dialog"
        border
        style="width: 100%; margin-top: 10px; margin-bottom: 10px"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          prop="itemIndex"
          label="序号"
          align="left"
          width="80"
        />
        <el-table-column prop="orderNumber" label="订单号" align="left" width="100" />
        <el-table-column
          prop="materialNumber"
          label="物品代码"
          align="left"
          min-width="120"
        />
        <el-table-column prop="productName" label="物品名称" align="left" min-width="140" />
        <el-table-column prop="productNum" label="数量" align="left" />
        <el-table-column
          prop="productPriceSigle"
          label="实际结算单价"
          align="right"
          width="100"
          header-align="left"
        />
        <el-table-column
          prop="settlementAmount"
          label="实际结算金额"
          align="right"
          width="100"
          header-align="left"
        />
        <el-table-column
          prop="freightAttributeName"
          label="货运方式"
          align="left"
          width="100"
        />
        <el-table-column
          prop="expectedDeliveryDate"
          label="客户期望发货日"
          align="left"
          width="150"
        />
        <el-table-column
          prop="agreedDate"
          label="约定交付日期"
          align="left"
          width="150"
        />
        <!-- <el-table-column prop="reason" label="待定原因" align="left" width="70" />
        <el-table-column prop="deliverState" label="发货状态" align="left" /> -->
      </el-table>
      <p style="font-size: 16px; font-weight: 800; margin: 10px 0">
        原信息
      </p>
      <p>
        <span>收货地址：</span>
        <span>{{ applyGoodsBaseInfo.primaryReceiptAddress }}</span>
      </p>
      <p>
        <span>运输方式：</span>
        <span>{{ applyGoodsBaseInfo.primaryModelOfShipping }}</span>
        <span style="margin-left: 20px">承运商：</span>
        <span>{{ applyGoodsBaseInfo.primaryCarrier }}</span>
      </p>
      <p style="font-size: 16px; font-weight: 800; margin: 10px 0">
        变更后信息
      </p>
      <p>
        <span>变更后收货地址：</span>
        <span>{{ address.receiverName }}</span>
        <span>{{ address.province }}</span>
        <span>{{ address.city }}</span>
        <span>{{ address.county }}</span>
        <span>{{ address.receiptAddress }}</span>
        <span>{{ address.receiverPhone }}</span>
        <span>
          <el-button
            v-if="address.receiverName"
            type="text"
            style="padding: 0; margin-left: 15px"
            @click="updateAdd"
          >更改地址</el-button>
          <el-button
            v-if="!address.receiverName"
            type="text"
            style="padding: 0; margin-left: 15px"
            @click.stop="showAddress = true"
          >选择地址</el-button>
        </span>
      </p>
      <div v-loading="loadingChange">
        <p>
          <span>变更后运输方式：</span>
          <span class="rj-baseinfo__item">
            <el-radio-group v-model="shippingType" @change="shippingTypeChange">
              <el-radio :label="0">陆运</el-radio>
              <el-radio :label="1" :disabled="isHaveBattery">航空</el-radio>
            </el-radio-group>
          </span>
          <span>变更后承运商：</span>
          <span>
            <el-select
              v-model="carrierChangeValue"
              :disabled="isCarrierChangeValue"
              @change="carrierChange"
            >
              <el-option
                v-for="item in changeBussinessOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </span>
        </p>
        <p>
          <span style="margin-right: 30px">运费差价：{{ freight }}元</span>
          <span v-if="this.freight != 0" class="rj-baseinfo__label">运费支付方式：</span>
          <span v-if="this.freight != 0" class="rj-baseinfo__item">
            <el-radio-group v-model="form.isRebate" @change="changisRebate">
              <el-radio :label="false">现金</el-radio>
              <el-radio :label="true">返利</el-radio>
            </el-radio-group>
            <template v-if="form.isRebate">
              使用金额: {{ form.rebateAmount }} 元
              <!-- eslint-disable-next-line vue/require-component-is -->
              <component
                v-bind="dialogNode"
                @chooesSuccess="chooseRebateSuccess"
              /> </template><br>
          </span>
        </p>
      </div>
      <p>
        <span>唛头单号:</span>
        <el-input
          v-model.trim="applyGoodsBaseInfo.partialInvoiceDetail.marksNum"
          style="width: 150px; margin-right: 10px"
          placeholder="请输入唛头单号"
        />
        <span>
          <span v-if="isRequiredEmail" class="required-tip">*</span>
          授权邮箱:
        </span>
        <el-input
          v-model.trim="
            applyGoodsBaseInfo.partialInvoiceDetail.authorizationEmail
          "
          style="width: 200px"
          placeholder="请输入授权邮箱"
        />
      </p>
      <p>
        <span style="display: inline-block; margin-top: 5px; margin-bottom: 5px">收货回执及到货验收要求：</span>
        <el-input
          v-model.trim="
            applyGoodsBaseInfo.partialInvoiceDetail
              .receiptArrivalAcceptanceRequirements
          "
          type="textarea"
          :rows="3"
          placeholder="请输入收货回执及到货验收要求"
          maxlength="200"
          show-word-limit
        />
      </p>
      <p>
        <span>回执附件</span>
        <el-upload
          action=""
          multiple
          :show-file-list="false"
          :http-request="uploadaction"
          style="display: inline-block; margin: 0 10px"
        >
          <el-button :loading="isUploadLoading" type="primary">
            上传附件
          </el-button>
        </el-upload>
      </p>
      <div v-for="(item, index) in fileList" :key="index">
        <span
          style="margin-right: 10px; color: #409eff"
          @click="fileClick(item)"
        >{{ item.fileName }}</span>
        <span style="color: #409eff; cursor: pointer" @click="deleteFile(index)"><i class="el-icon-error" /></span>
      </div>
      <p>
        <span style="display: inline-block; margin-top: 5px; margin-bottom: 5px">发货备注说明：</span>
        <el-input
          v-model.trim="applyGoodsBaseInfo.partialInvoiceDetail.deliverRemark"
          type="textarea"
          :rows="3"
          placeholder="请输入发货备注说明"
          maxlength="200"
          show-word-limit
        />
      </p>
      <p>
        <span style="display: inline-block; margin-top: 5px; margin-bottom: 5px">备注：</span>
        <el-input
          v-model.trim="applyGoodsBaseInfo.partialInvoiceDetail.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
          maxlength="200"
          show-word-limit
        />
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialogVisible = false">关 闭</el-button>
        <el-button type="danger" :loading="rejectLoading" @click="reject">驳回</el-button>
        <el-button type="primary" :loading="subLoading" @click="submit">提交</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    <address-box
      :prop-open.sync="showAddress"
      @chooseAddress="changeAddress"
      @ChangeDatas="ChangeDatas"
    />
  </div>
</template>
<script type="es6">
import { MathAdd, MathMulti } from '@/libs/util';
import addressBox from '@/views/address/index.vue';
import rebateUse from '../rabateUse';
import rebateUsedList from '../rebateUsedList';
import { mapState } from 'vuex';
import AxiosApi from '@/API/fileAxios';
import {
  attachmentGetToken,
  agentGetPartialInvoiceDetail,
  getReceiptAddressInfoModel,
  getReceiptAddressByContractId,
  agentConfirmApplyPartialShipment,
  agentRevokeApply,
  getPartialShipmentFreight,
  getEditRebateUsedList,
  getRebateSummaryAgentInfo
} from '@/API';
import { mailboxVerification } from '@/API/international';
// import Collapse from '@/components/Collapse';
/* eslint-disable */
export default {
  data () {
    return {
      dialogVisible: this.fpfhDialog,
      tableData_dialog: [],
      shippingType: '陆运',
      loading: false,
      address: {},
      loadingChange: false,
      subLoading: false,
      isHaveBattery: false,
      showAddress: false,
      carrierChangeValue: "默认物流",
      isCarrierChangeValue: false,//承运商是否可点击
      changeBussinessOptions: ["默认物流", "顺丰"],
      specialCloudDesc:'',
      freight: "0", //运费差价
      applyGoodsBaseInfo: {
        primaryReceiptAddress: '',
        primaryModelOfShipping: '',
        primaryCarrier: '',
        receiptAddress: '',
        modeOfShipping: '',
        carrier: '',
        freight: '',
        freightPayTypeStr: '',
        freightContractNum: '',
        freightProportion: '',
        marksNum: '',
        authorizationEmail: '',
        receiptArrivalAcceptanceRequirements: '',
        deliverRemark: '',
        remark: '',
        approvalOpinion: '',
        partialInvoiceDetail: {
          remark: ''
        },

      },
      form: {
        isRebate: false,
        rebateAmount: "",
      },
      sourceModifyAddress: true,
      // 文件参数
      uploadUrl: '',
      downFileUrl: '',
      fileserveDownUrl: '',
      token: '',
      fileList: [],
      rejectLoading: false,
      dialogNode: {
        is: "",
        allow: 0,
        availableRebateAmount: 0,
        rebateUsedList: [],
      },
      // 验证邮箱是否需要必填
      isRequiredEmail: false,
      isUploadLoading: false

    };

  },
  props: {
    fpfhDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    fpfhId: {
      type: Number,
      default: 0
    },
    // contractType: {
    //   type: [String, Number],
    //   required: '',
    // },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    addressBox,
    rebateUse,
    rebateUsedList,
  },
  computed: {
    ...mapState({
      salesType: (state) => state.enumeration.salesType,
      shipType: (state) => state.enumeration.shipType,
    }),
    allowUserRate () {
      return MathMulti(this.form.orderSales, 0.3);
    },
  },
  watch: {
    freight (val) {
      this.dialogNode.allow = this.freight; //最大返利金额   运费差价字段
    },
    fpfhDialog (val) {
      // 打开弹框重置数据
      if(val){
         this.isRequiredEmail = false;
      }
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },
  methods: {
    async partDialogOpen () {
      this.initData();
      //判断是否是分销下单
      // if (this.contractType === 'SMB分销下单') {
      //   this.carrierChangeValue = this.carrierOld ? this.carrierOld : '默认物流'
      //   this.shippingType = this.shippingTypeOld ? this.shippingTypeOld : 0
      // }
      var res = await getReceiptAddressByContractId(this.fpfhId);
      const json = res.data;
      if (json.status === "200") {
        let data = json.data;
        if (data === null) {
          data = [];
        }
        this.address = data;
        this.$emit("chooseAddress", json.data);
      } else {
      }
      this.getEditRebateUsedList(); //返利查询
    },
    async closeDialog () {
      this.shippingType = 0;
      this.freight = 0;
      this.carrierChangeValue = "默认物流";
      this.form.isRebate = false;
      this.fileList = [];
    },
    shippingTypeChange () {
      this.fecthFreightDifference();
    },
    carrierChange () {
      if (this.carrierChangeValue === '默认物流' && this.contractType !== 'SMB分销下单') {
        this.freight = 0;
      } else {
        this.fecthFreightDifference();
      }
    },
    submit () {
      if(this.form.isRebate === true){
        if(this.form.rebateAmount !==this.freight ){
          this.$message.error('分批发货运费支付方式选择返利，必须全部使用返利')
          return
        }
      }
      if(this.isRequiredEmail  && !this.applyGoodsBaseInfo.partialInvoiceDetail.authorizationEmail){
        this.$message.error('请输入邮箱')
        return
      }

      this.subLoading = true;
      let parmars = {
        masterContractId: this.rowData.masterContractId,
        masterContractNum: this.rowData.masterContractNum,
        masterProjectName: this.rowData.masterProjectName,
        partialInvoiceFile: this.fileList, //文件
        partialId: this.rowData.id,
        detail: {
          id: this.applyGoodsBaseInfo.partialInvoiceDetail.id,
          partialId: this.applyGoodsBaseInfo.partialInvoiceDetail.partialId,
          partialAddressId: this.address.id,
          receiptAddressId: this.applyGoodsBaseInfo.partialInvoiceDetail.receiptAddressId,
          // receiptAddressId: this.applyGoodsBaseInfo.receiptAddressId,
          modeOfShipping: this.shippingType === 1 ? "航空" : "陆运", //货运方式
          carrier: this.carrierChangeValue, //承运商
          freight: this.freight, //运费差价
          freightPayType: this.form.isRebate ? 1 : 0, //支付方式
          freightUseRebate: null, //null
          amountSum: this.trueAccount(), //合计金额
          remark: this.applyGoodsBaseInfo.partialInvoiceDetail.remark, //备注
          deliverRemark: this.applyGoodsBaseInfo.partialInvoiceDetail
            .deliverRemark,
          receiptArrivalAcceptanceRequirements: this
            .applyGoodsBaseInfo.partialInvoiceDetail
            .receiptArrivalAcceptanceRequirements,
          authorizationEmail: this.applyGoodsBaseInfo.partialInvoiceDetail
            .authorizationEmail, //云桌面
          marksNum: this.applyGoodsBaseInfo.partialInvoiceDetail.marksNum, // 唛头单号
          approvalOpinion: "", //审批意见
        },
        rebateListVo: this.rebateListVo,//返利使用列表
        partialInvoiceProductList: this.tableData_dialog,
      };
      agentConfirmApplyPartialShipment(parmars).then((res) => {
        const json = res.data;
        this.subLoading = false;
        if (json.status === '200') {
          this.$message.success('提交成功')
          this.dialogVisible = false;
        }
      }).catch(() => {
        this.subLoading = false;
      });
    },
    reject () {
      this.rejectLoading = true;
      agentRevokeApply({ 'id': this.fpfhId, 'approvalOpinion': '' }).then((res) => {
        let json = res.data;
        // this.$refs.gridTable.doClose();
        this.rejectLoading = false;
        if (json.status === '200') {
          this.$message.success('驳回成功')
          this.dialogVisible = false;

        }
      }).catch(() => {
        this.rejectLoading = false;
      });

    },
    //文件上传
    uploadaction (upload) {
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.isUploadLoading = true
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        this.isUploadLoading = false
        const json = res.data;
        if (json.status === '200') {
          this.fileList.push({
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID,
          })
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        this.isUploadLoading = false
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    deleteFile (tag) {
      this.fileList.splice(tag, 1);
    },
    // 下载文件地址
    fileClick (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    //实际结算金额
    trueAccount () {
      let cont = 0;
      this.tableData_dialog.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      // cont = Number(cont).toFixed(2);
      return cont;
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.label === "未发货数量") {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === "数量") {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === "实际结算金额") {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },
    // 实际结算金额总计
    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      // cont = Number(cont).toFixed(2);
      return cont;
    },
    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    //判断当前状态 返回不同 shippingType
    getType () {
      this.shippingType = 0;
    },
    // 校验是否含有电池和计算运费差价接口
    async fecthFreightDifference () {
      this.loadingChange = true;
      this.isHaveBattery = false;
      let params = {
        contractNum: this.rowData.masterContractNum,
        shippingType: this.shippingType,
        receiptAddressId: this.address.id,
        partialInvoiceProductList: this.tableData_dialog,
        carrier: this.carrierChangeValue
      };
      const res = await getPartialShipmentFreight(params);
      this.loadingChange = false;
      const json = res.data;
      if (json.status === "200") {
        this.freight = json.data;
        //默认物流 +陆运 = 0;
        if (this.carrierChangeValue == '默认物流' && this.shippingType == 0 && this.contractType !== 'SMB分销下单') {
          this.freight = 0;
        }
      } else if (json.status === "7100023") {
        // 包含电池状态码：7100023，不能选择航空
        this.isHaveBattery = true;

        this.getType()
      } else {
        this.getType()
      }
      // 如果是航空，禁用选择承运商
      if (this.shippingType == 1) {
        this.isCarrierChangeValue = true;
      } else {
        this.isCarrierChangeValue = false;
      }
    },
    //初始 数据
    initData () {
      //调用回显接口
      let parmas = { id: this.fpfhId };
      agentGetPartialInvoiceDetail(parmas).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.applyGoodsBaseInfo = json.data;
          this.tableData_dialog = json.data.partialInvoiceProductList;
          this.address = json.data.receiptAddress;
          this.carrierChangeValue = json.data.partialInvoiceDetail.carrier;
          this.freight = json.data.partialInvoiceDetail.freight;
          this.shippingType = json.data.partialInvoiceDetail.modeOfShipping === '航空' ? 1 : 0;
          this.isCarrierChangeValue = this.shippingType === 1?true:false;
          this.sourceModifyAddress = json.data.change;
          this.contractType = json.data.contractType;
          this.fileList = json.data.reversedInvoiceVO;
          this.specialCloudDesc = json.data.specialCloudDesc;

          // 验证邮箱是否需要必填
          this.checkEmailIsRequired(json.data.partialInvoiceProductList)
        }
      }).catch(() => {
      });
    },
    // 返利
    changisRebate (val) {
      if (!val) {
        this.form.rebateAmount = 0;
        this.dialogNode.rebateUsedList = [];
      }
    },
    chooseRebateSuccess (val) {
      this.rebateListVo = [];
      //转化数组格式
      val.list.forEach((item) => {
        this.rebateListVo.push({
          rebateNum: item.rebateNumber,
          rebateTypeName: item.strRebateType,
          rebateAmount: item.useAmount,
        });
      });
      // 赋值过程toFixed();
      this.form.rebateAmount = val.total;
      this.dialogNode.rebateUsedList = val.list;
    },
    //返利 接口
    getEditRebateUsedList () {
      getEditRebateUsedList({ contractNum: this.rowData.masterContractNum })
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            if (json.data.length) {
              this.dialogNode.rebateUsedList = json.data;
              this.dialogNode.is = "rebate-used-list";
            } else {
              this.dialogNode.is = "rebate-use";
            }
          }
        })
        .catch(() => { });
      getRebateSummaryAgentInfo({ contractNum: this.rowData.masterContractNum })
        .then((res) => {
          let json = res.data;
          if (json.status === "200") {
            this.dialogNode.availableRebateAmount = json.data.availableAmount;
          }
        })
        .catch(() => { });
    },
    updateAdd () {
      if (this.contractType === 'SMB分销下单' && this.sourceModifyAddress) {
        this.$message.error('抱歉，您已修改过发货地址，不允许再次修改地址');
        return false;
      }
      this.showAddress = true
    },
    changeAddress (val) {
      // 选择其他地址
      this.address = val;
      this.showAddress = false;
      //调用运费接口
      this.fecthFreightDifference();
      this.$emit("chooseAddress", val);
      this.$emit("changeAddress");
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id)
          .then((res) => {
            let json = res.data;
            if (json.status === "200") {
              if (!json.data.isDelete) {
                this.address = json.data;
              } else {
                this.address = {};
              }
            }
          })
          .catch(() => { });
      }
    },

    // 验证邮箱是否需要必填
    checkEmailIsRequired(array){
      let params =  array.map((item) => item.materialNumber);
      mailboxVerification(params).then(res => {
        let {status, data} = res.data
        if (status === '200') {
          this.isRequiredEmail = data
        }
      })
    }

  },
  mounted () {
    this.initToken();
  },
};
</script>
<style scope>
.partShipment p {
  margin: 5px 0;
}

.required-tip{
  position: relative;
  left: 10px;
  color: red;
}
</style>
